import { type ButtonHTMLAttributes, memo } from "react";
import cn from "classnames";
import styles from "./performanceLinkButton.module.scss";

const PerformanceLinkButtonComponent = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { className, children, ...rest } = props;
  return (
    <button className={cn(styles.performanceLinkButton, className)} {...rest}>
      {children}
    </button>
  );
};

export const PerformanceLinkButton = memo(PerformanceLinkButtonComponent);
